import { MatchInterviewType } from '../match/match-interview-type';

export const INTERVIEW_TIME_SLOT_TYPES = [MatchInterviewType.Interview, MatchInterviewType.TrialDay] as const;

export type InterviewTimeSlotType = (typeof INTERVIEW_TIME_SLOT_TYPES)[number];
